var map = {
	"./prism-coy.css": [
		59922,
		59922
	],
	"./prism-coy.min.css": [
		55499,
		55499
	],
	"./prism-dark.css": [
		46533,
		46533
	],
	"./prism-dark.min.css": [
		14539,
		14539
	],
	"./prism-funky.css": [
		17321,
		17321
	],
	"./prism-funky.min.css": [
		43245,
		43245
	],
	"./prism-okaidia.css": [
		92751,
		92751
	],
	"./prism-okaidia.min.css": [
		21999,
		21999
	],
	"./prism-solarizedlight.css": [
		15827,
		15827
	],
	"./prism-solarizedlight.min.css": [
		55342,
		55342
	],
	"./prism-tomorrow.css": [
		21478,
		21478
	],
	"./prism-tomorrow.min.css": [
		80663,
		80663
	],
	"./prism-twilight.css": [
		45113,
		45113
	],
	"./prism-twilight.min.css": [
		96425,
		96425
	],
	"./prism.css": [
		78795,
		78795
	],
	"./prism.min.css": [
		73381,
		73381
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 62660;
module.exports = webpackAsyncContext;